import React, { FC, HTMLAttributes, useState } from 'react';
import { Field } from 'react-final-form';
import { t } from 'utils';
import { Button, Card, Tooltip } from 'components/ui';
import { TextInputWrapper } from 'components/forms';
import { Error } from 'components';
import styles from './Form.module.scss';
import classNames from 'classnames';
export interface IAuthoriseAccounts extends HTMLAttributes<HTMLDivElement> {
  isValid?: boolean;
  values: any;
}

const AuthoriseAccounts: FC<IAuthoriseAccounts> = (props) => {
  const { isValid, values } = props;
  let { environments: formValue } = values || {};
  formValue = formValue || '';
  const [showTooltip, setShowTooltip] = useState<boolean>(true);

  return (
    <Card title='form.step.app.authorise.accounts.title'>
      <Field
        name='environments'
        component={TextInputWrapper}
        placeholder='form.step.app.authorise.accounts.placeholder'
        className='mb-2'
      />
      <Error isError={formValue.length > 0 && !isValid}>{t('private.access.code.invalid')}</Error>
      <Tooltip className='authorise__tooltip' showTooltip={showTooltip}>
        <h3 className={styles.title}>
          <span className={classNames(styles.icon, 'fas fa-lightbulb')} />
          {t('form.step.app.authorise.accounts.tooltip.forget.title')}
        </h3>
        <p className={styles.text}>{t('form.step.app.authorise.accounts.tooltip.forget.text')}</p>
        <h4 className={styles.questionTitle}>
          {t('form.step.app.authorise.accounts.tooltip.why.title')}
        </h4>
        <p className={styles.text}>{t('form.step.app.authorise.accounts.tooltip.why.text')}</p>
        <Button className={styles.button} onClick={() => setShowTooltip(false)} inline>
          {t('form.step.app.authorise.accounts.tooltip.button.label')}
        </Button>
      </Tooltip>
    </Card>
  );
};

export default AuthoriseAccounts;
